// src/utils/gardeMolette.js
// La molette de la souris ne modifie plus jamais un champ numérique.
//
// Constat du 12/10/2026 à csap1 : 18 élèves inscrits avec une réduction de
// 999, 998 ou 497 au lieu de 1 000 ou 500, d'où des mensualités de 8 001,
// 5 003 ou 10 002. Un <input type="number"> qui garde le focus change de
// valeur à chaque cran de molette quand le curseur passe dessus : l'agent fait
// défiler le formulaire et retire 1, 2, 3 francs sans le voir. Aucun des
// champs numériques de l'application n'en était protégé, et dans « Modifier la
// famille » (step="100") un cran valait 100 francs.
//
// Le champ perd le focus au premier cran, avant que le navigateur n'applique
// le pas : la valeur ne bouge pas et la page défile normalement. Pas de
// preventDefault, qui exigerait un écouteur non passif et bloquerait le
// défilement des fenêtres ouvertes.

let installee = false;

export function installerGardeMolette() {
  if (installee || typeof document === 'undefined') return;
  installee = true;

  document.addEventListener(
    'wheel',
    (evenement) => {
      const champ = evenement.target;
      if (
        champ instanceof HTMLInputElement &&
        champ.type === 'number' &&
        document.activeElement === champ
      ) {
        champ.blur();
      }
    },
    { capture: true, passive: true }
  );
}
